export default "/images/align-right.svg?08dcc004b6be422dffa2095de65cb42c";